import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRough = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16.11 5H27.5L43 27.5 35 43H12.5L5 20zm1.39 3-9 12.5L15 40h18l6.5-12.227L26 8z" })
});
export default SvgRough;
